import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import MOCK_DATA from './surfProtector.json';

const index = (req, res, ctx) => {
  const responseData = MOCK_DATA['surfProtector/index'].success.default;

  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const queryUsers = (req, res, ctx) => {
  const responseData = MOCK_DATA['surfProtector/queryUsers'].success.default;

  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const childSettings = (req, res, ctx) => {
  const responseData = MOCK_DATA['/eservice/api/surfProtector/childSettings'].success.default;

  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const updateBlockType = (req, res, ctx) => {
  const responseData = MOCK_DATA['/eservice/api/surfProtector/updateBlockType'].success.default;

  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

const modifyUser = (req, res, ctx) => {
  const mockConfig = MOCK_DATA['/eservice/api/surfProtector/modifyuser'];
  const responseData = mockConfig.success.default;
  return res(ctx.status(200), ctx.json(mockResponse(responseData)));
};

export const handlers = [
  rest.post(getApiEndpoint('surfProtector/index'), withScenario(withAuthCheck(index))),
  rest.post(getApiEndpoint('surfProtector/queryUsers'), withScenario(withAuthCheck(queryUsers))),
  rest.post(getApiEndpoint('surfProtector/childSettings'), withScenario(withAuthCheck(childSettings))),
  rest.post(getApiEndpoint('surfProtector/updateBlockType'), withScenario(withAuthCheck(updateBlockType))),
  rest.post(getApiEndpoint('surfProtector/modifyuser'), withScenario(withAuthCheck(modifyUser))),
];
